import { render, staticRenderFns } from "./newspaper.vue?vue&type=template&id=5e9258f2&functional=true"
import script from "./newspaper.vue?vue&type=script&lang=js"
export * from "./newspaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports